import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
} from "reactstrap";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { Loader } from "rsuite";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { base_url } from "../../constants";
import QuestionCoursesTable from "./QuestionCoursesTable/QuestionCoursesTable";

const QuestionCoursesList = () => {
  document.title = "Question Courses | Medicotoon";
  const navigate = useNavigate();
  const localdata = localStorage.getItem("elmatary_admin");
  let adminData = localdata && JSON.parse(localdata);

  const [courses, setCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [univs, setUnivs] = useState([]);
  const [selectedUnivs, setSelectedUnivs] = useState(false);
  const [filterGrades, setFilterGrades] = useState(false);
  const [selectGrades, setSelectGrades] = useState(false);

  const getCourses = async () => {
    setLoading(true);
    try {
      const data_send = {
        admin_id: adminData.admin_id,
        access_token: adminData.access_token,
      };
      const res = await axios.post(
        `${base_url}/admin/courses/select_courses.php`,
        JSON.stringify(data_send)
      );

      if (res.message === "Session Expired") {
        localStorage.removeItem("elmatary_admin");
        navigate("/login", { replace: true });
        return;
      }

      if (res.status === "success" && Array.isArray(res.message)) {
        const questionOnlyCourses = res.message.filter(
          (c) => c.course_type === "questions"
        );
        setCourses(questionOnlyCourses);
        setFilteredCourses(questionOnlyCourses);
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to load courses");
    } finally {
      setLoading(false);
    }
  };

  const getUnivs = async () => {
    try {
      const data_send = {
        admin_id: adminData.admin_id,
        access_token: adminData.access_token,
      };
      const res = await axios.post(
        `${base_url}/admin/universities/select_universities_grade.php`,
        JSON.stringify(data_send)
      );
      if (res.status === "success" && Array.isArray(res.message)) {
        setUnivs(res.message);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getCourses();
    getUnivs();
  }, []);

  const getFilterGrades = () => {
    setFilterGrades(
      univs?.filter((item) => item.university_id === selectedUnivs)[0]?.grades
    );
  };

  useEffect(() => {
    let arr = [];
    if (filteredCourses && filteredCourses.length) {
      if (selectedUnivs) {
        arr = filteredCourses.filter(
          (item) => item?.university_id === selectedUnivs
        );
        setCourses([...arr]);
        getFilterGrades();
      } else {
        setFilterGrades(false);
        setCourses(filteredCourses);
      }
    }
  }, [selectedUnivs, filteredCourses]);

  useEffect(() => {
    let arr = [];
    if (filteredCourses && filteredCourses.length) {
      if (selectGrades) {
        arr = filteredCourses.filter(
          (item) => item?.grade_id === selectGrades
        );
        setCourses([...arr]);
      } else if (selectedUnivs) {
        arr = filteredCourses.filter(
          (item) => item?.university_id === selectedUnivs
        );
        setCourses([...arr]);
      } else {
        setCourses(filteredCourses);
      }
    }
  }, [selectGrades, selectedUnivs, filteredCourses]);

  const showHideCourse = async (send_data) => {
    try {
      const data_send = {
        ...send_data,
        admin_id: adminData.admin_id,
        access_token: adminData.access_token,
      };
      const res = await axios.post(
        `${base_url}/admin/courses/show_hide_course.php`,
        JSON.stringify(data_send)
      );
      if (res.status === "success") {
        toast.success(res.message);
        getCourses();
      } else {
        toast.error(res.message || "Failed to update course");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error updating course status");
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title="Question Courses"
            breadcrumbItem="Question Courses List"
          />

          {/* Universities Filter Badges */}
          <div className="univs mb-2">
            {univs && univs.length
              ? univs.map((item, index) => (
                  <span
                    key={index}
                    className={
                      selectedUnivs && selectedUnivs === item?.university_id
                        ? "active"
                        : ""
                    }
                    onClick={() =>
                      selectedUnivs === item?.university_id
                        ? setSelectedUnivs(false)
                        : setSelectedUnivs(item?.university_id)
                    }
                  >
                    {item?.university_name}
                  </span>
                ))
              : null}
          </div>

          {/* Grades Filter Badges */}
          <div className="univs mb-3">
            {filterGrades && filterGrades.length
              ? filterGrades.map((item, index) => (
                  <span
                    key={index}
                    className={
                      selectGrades && selectGrades === item?.grade_id
                        ? "active"
                        : ""
                    }
                    onClick={() =>
                      selectGrades === item?.grade_id
                        ? setSelectGrades(false)
                        : setSelectGrades(item?.grade_id)
                    }
                  >
                    {item?.grade_name}
                  </span>
                ))
              : null}
          </div>

          <Row>
            <Col lg={12}>
              <Card className="shadow-sm">
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h5 className="card-title font-size-16 mb-0 text-primary">
                      <i className="bx bx-help-circle me-1"></i> Question
                      Courses Management
                    </h5>
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => navigate("/question-courses/add")}
                    >
                      <i className="mdi mdi-plus me-1"></i> Add Question Course
                    </button>
                  </div>

                  {loading ? (
                    <div className="text-center py-5">
                      <Loader />
                    </div>
                  ) : (
                    <QuestionCoursesTable
                      courses={courses}
                      showHideCourse={showHideCourse}
                      getCourses={getCourses}
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
};

export default QuestionCoursesList;
